import { type ReactNode } from 'react';
import { cn } from '@/utils';
export type RollBannerItem = {
  id?: string;
  leftSlot: ReactNode;
  title: ReactNode;
  thumbnailImage: string;
  contentClick?: () => void;
};
export const RollingBannerItem = (props: RollBannerItem) => {
  const {
    leftSlot,
    contentClick,
    title,
    thumbnailImage
  } = props;
  return <div className="keen-slider__slide flex h-[48px] w-full items-center justify-between gap-2xs" data-sentry-component="RollingBannerItem" data-sentry-source-file="RollingBannerItem.tsx">
      <div onClick={contentClick} className={cn('flex flex-1 h-[29px] max-w-full items-center gap-3xs', {
      'cursor-pointer': contentClick
    })}>
        <span className="w-[18px] text-body-lg-bold text-strong">
          {leftSlot}
        </span>
        <div style={{
        maxWidth: 'calc(100% - 44px)'
      }} className="flex w-full min-w-0 items-center justify-between gap-3xs">
          <div className="flex h-full min-w-0 max-w-[90%] shrink items-center truncate text-body-md-semibold text-default">
            {title}
          </div>
        </div>
        {thumbnailImage && <img src={thumbnailImage} className="h-[28px] w-[44px] shrink-0 rounded-sm" alt="thumbnail" />}
      </div>
    </div>;
};